<div class="booking-entry relative">
  <cms-disruptions [disruptions]="disruptions$ | async" />

  <div class="relative bg-container">
    <fin-content-image
      class="background-image"
      [imageData$]="backgroundImg$"
      [aspectRatio$]="aspectRatio$"
      [fetchPriority]="FetchPriorityEnum.high"
      [isLazyLoad]="false"
    />
    <fin-booking-widget [compactMode]="true" [defaultLocations$]="defaultLocations | finToObservable" />
  </div>
</div>
